import React, { Fragment } from 'react';
import { Tag } from 'antd';
import { connect } from 'dva';
import { formatPrice, formatTimestamp } from 'utils/utils.js';
import { payStatusMapArr, payMethodMapArr } from 'utils/enum/state-enum.js';
import styles from './Order.less';
import ColGroup from './ColGroup.js';

@connect()
export default class Order extends React.Component {
  constructor(props) {
    super(props);

    this.renderCommodity = this.renderCommodity.bind(this);
    this.handleQueryDetail = this.handleQueryDetail.bind(this);
  }

  handleQueryDetail(orderNo) {
    const { dispatch } = this.props;

    dispatch({
      type: 'merchantOrder/fetchOrderDetail',
      id: orderNo,
    });

    dispatch({
      type: 'merchantOrder/toggleModalVisibility',
      modal: {
        show: true,
      },
    });
  }

  renderCommodity(
    orderNo,
    commodity,
    index,
    length,
    { userName, mobile, gmtPaid, status, totalPrice }
  ) {
    const { commodityName, images, price: commodityPrice, propertyValues } = commodity;
    const firstImage = images.split(',')[0];
    const statusChinese = payStatusMapArr.find(q => q.key === status);

    return (
      <tr key={`${commodityName}-${commodityPrice}-${propertyValues}`}>
        <td className="commodity-name">
          <div>
            <div>
              <img className="thumbnail" src={firstImage} alt="commodity" />
            </div>
            <div className="text">
              <p className="name">{commodityName}</p>
              <div className="tags">
                {propertyValues &&
                  propertyValues.map(property => (
                    <Tag key={property} color="#F3F3F3">
                      {property}
                    </Tag>
                  ))}
              </div>
            </div>
          </div>
        </td>

        <td className="commodity-price">
          <div>
            <p>¥{formatPrice(commodityPrice)}</p>
          </div>
        </td>

        {index === 0 && (
          <Fragment>
            <td className="commodity-user-info" rowSpan={length + 1}>
              <div>
                <p>{userName}</p>
                <p>{mobile}</p>
              </div>
            </td>

            <td className="commodity-pay-info" rowSpan={length + 1}>
              <div>
                <p>{status === 'PAY_SUCCESS' ? formatTimestamp(gmtPaid) : '-'}</p>
              </div>
            </td>

            <td className="commodity-status" rowSpan={length + 1}>
              <div>
                <p>{statusChinese ? statusChinese.value : '-'}</p>
              </div>
            </td>

            <td className="commodity-actual-price" rowSpan={length + 1}>
              <div>
                <p>¥{formatPrice(totalPrice)}</p>
                <div>
                  <a
                    onClick={() => {
                      this.handleQueryDetail(orderNo);
                    }}
                  >
                    查看详情
                  </a>
                </div>
              </div>
            </td>
          </Fragment>
        )}
      </tr>
    );
  }

  render() {
    const {
      data: { orderNo, orgName, payMethod, commodities, userName, mobile, gmtPaid, status, price },
    } = this.props;
    const payMethodChinese = payMethodMapArr.find(q => q.key === payMethod);

    return (
      <table className={styles.root}>
        <ColGroup />
        <tbody className="head">
          <tr>
            <td colSpan={6}>
              <span className="order-no">订单号：{orderNo}</span> / {orgName} /{' '}
              {payMethodChinese && payMethodChinese.value}
            </td>
          </tr>
        </tbody>

        <tbody className="commodity">
          {commodities.map((commodity, index, array) => {
            return this.renderCommodity(orderNo, commodity, index, array.length, {
              userName,
              mobile,
              gmtPaid,
              status,
              totalPrice: price,
            });
          })}
        </tbody>
      </table>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/Merchant/Order/Table/Order.js